(function () {
	'use strict';

	/**
	 * @ngdoc directive
	 * @name mx.components:hoverClass
	 * @module mx.components
	 * @restrict 'A'
	 * @description
	 * Add?remove class to an element on mouseenter/mouseleave
	 *
	 * @param {string} hoverClass= - Class which will be added
	 *
	 * @usage <mx-some-component mx-hover-class="some-hovered-class"></mx-some-component>
	 */

	angular.module('mx.components').directive('mxHoverClass', function mxHoverClassDirective() {
		return {
			restrict: 'A',
			scope: {
				mxHoverClass: '@',
			},
			link: function (scope, element) {
				element.on('mouseenter', function () {
					element.addClass(scope.mxHoverClass);
				});
				element.on('mouseleave', function () {
					element.removeClass(scope.mxHoverClass);
				});
			},
		};
	});
})();
